import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import {
  Table,
  TableActions,
  TableColumn,
  TableContainer,
  Typography,
} from '_template';
import DateTime from 'components/DateTime';
import ButtonDelete from 'components/ButtonDelete';
import { GetConsultantHistoryListQuery } from 'modules/ConsultantHistory/query';

interface ConsultantHistoryListProps {
  consultantId: string;
}

const ConsultantHistoryList = ({
  consultantId,
}: ConsultantHistoryListProps) => {
  const { t } = useTranslation();

  const historyListQuery = useQuery(GetConsultantHistoryListQuery, {
    variables: {
      where: {
        consultantId,
      },
      limit: {
        limit: 10000,
        offset: 0,
      },
      orderBy: {
        sortField: 'createdAt',
        sortBy: 'DESC',
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  const { data, loading, error, refetch } = historyListQuery;

  const emails = data?.consultantHistoryList?.rows || [];

  return (
    <TableContainer>
      <Table<GQL.IConsultantHistory>
        dataSource={emails}
        recordsCount={emails?.length}
        loading={loading}
        error={error}
        disablePaginate
      >
        <TableColumn
          label={t('CONSULTANT_HISTORY.CREATED_AT')}
          dataIndex="createdAt"
          sx={{ width: 150 }}
          align="center"
          render={({ createdAt }: GQL.IConsultantHistory) => (
            <DateTime value={createdAt} />
          )}
        />
        <TableColumn
          label={t('CONSULTANT_HISTORY.CONTENT')}
          dataIndex="recipient"
          render={(row: GQL.IConsultantHistory) => (
            <Typography>
              {row.content}
              {/* <br />
              <div dangerouslySetInnerHTML={{ __html: row.description! }} /> */}
            </Typography>
          )}
        />
        <TableColumn
          label={t('CONSULTANT_HISTORY.CREATOR')}
          dataIndex="creator"
          render={(row: GQL.IConsultantHistory) => (
            <Typography>{row.creator}</Typography>
          )}
        />
        <TableActions
          render={(row: GQL.IConsultantHistory) => {
            return (
              <ButtonDelete
                message={t('CONSULTANT_HISTORY.REALLY_TO_DELETE')}
                disabled
                // onDelete={() => deleteFile({ variables: { id: row.id } })}
                refetch={refetch}
              />
            );
          }}
        />
      </Table>
    </TableContainer>
  );
};

export default ConsultantHistoryList;
